export default __webpack_public_path__ + "static/media/blogIndex4.4125d199.png";